<template>
  <div class="relative flex lg:justify-end justify-center">
    <main
      class="p-4 md:p-4 wallet__container flex flex-row shadow-sm items-center"
    >
      <div
        class="h-full flex flex-col justify-between items-start wallet__container__sec1 w-full"
      >
        <div class="flex justify-start flex-col items-start gap-2">
          <img
            class="w-full"
            src="@/assets/images/user-dashboard/walletcard_logo.png"
          />

          <h4 class="text-base uppercase text-slate-500">Mohammed Yasrab</h4>
        </div>

        <div class="flex justify-start flex-col items-start gap-2">
          <h3 class="text-xl font-semibold">Knowledge</h3>

          <h5 class="text-lg font-medium" id="xp">1105 KT ~ $2695</h5>
        </div>

        <h3 class="text-lg font-medium text-slate-500">1234 1234 1234 1234</h3>
      </div>

      <div
        class="h-full flex flex-col justify-between items-end wallet__container__sec2 w-full"
      >
        <div class="flex flex-col justify-end items-end h-full gap-6">
          <img
            class="w-16"
            src="@/assets/images/user-dashboard/walletcard_chip.png"
          />

          <h5 class="text-xl font-semibold" id="xp">{{ xp }} XP</h5>

          <div class="flex flex-row gap-8">
            <div class="flex flex-col justify-start items-start">
              <p class="text-sm font-medium text-black">Synced</p>
              <h6 class="text-sm font-medium">40 XP</h6>
            </div>

            <div class="flex flex-col justify-end items-end">
              <p
                class="text-sm text-white"
                style="filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.25))"
              >
                Pending
              </p>
              <h6
                class="font-medium text-sm text-white"
                style="filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.25))"
              >
                60 XP
              </h6>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "UserWalletCard",
  data() {
    return {
      xp: 0,
    };
  },
  computed: {
    userTokens() {
      return this.$store.state.users.userTokens;
    },
    userWidgets() {
      return this.$store.state.dashboard.userWidgets;
    },
    configDashboard() {
      return this.$store.state.dashboard.configDashboard;
    },
    isAnimationTrue() {
      return this.$store.state.animation.isAnimationTrue;
    },
  },
  watch: {
    userTokens: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          setTimeout(() => {
            this.getUserXP(newVal);
          }, 1250);
        }
      },
    },
  },
  mounted() {
    setTimeout(() => {
      const fp = document.getElementById("xp").getBoundingClientRect();
      this.$store.commit("animation/SET_FINAL_POSITION_FOR_XP", {
        top: fp.top,
        bottom: fp.bottom,
        left: fp.left,
        right: fp.right,
      });
    }, 750);
  },
  methods: {
    removeUserWalletCard() {
      const userWallet = this.userWidgets.find(
        (item) => item.widgetId === "USER_WALLET"
      );
      this.$store
        .dispatch("dashboard/removeWidget", userWallet)
        .then(() => {
          for (var i = 0; i < this.userWidgets.length; i++) {
            if (this.userWidgets[i].widgetId === "USER_WALLET") {
              this.$store.commit("dashboard/REMOVE_WIDGET", i);
            }
          }
          this.$store.commit("dashboard/SHOW_QUEUE_CARD", false);
        })
        .catch((err) => {
          throw err;
        });
    },
    getUserXP(tokens) {
      if (tokens) {
        // 0 is for xp
        const xpObj = tokens.find((obj) => obj.key === 0);
        if (xpObj) {
          this.xp = xpObj.value;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wallet__container {
  background-image: url("../../../assets/images/user-dashboard/walletcard_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  background-color: white;
  height: 220px;
  width: 350px;
}
</style>
